import axios from "axios";
import { host } from "./utilities";


export const getRegistriesListAxios =
  () =>
    (config) =>
      axios.get(`${host()}/reference-data/registries`, config);
